import React from 'react';

/**
 * DataTable — semantic <table> on desktop, converted to stacked cards on
 * mobile via data-label (header text is preserved as each cell's label).
 *
 * columns: [{ key, label }]
 * rows:    [{ key: value, ... }] — first column is emphasised as the row key.
 */
const DataTable = ({ columns, rows, caption, className = '' }) => (
  <div className="cy-table-wrap">
    <table className={`cy-table ${className}`}>
      {caption ? <caption>{caption}</caption> : null}
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key} scope="col">
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            {columns.map((col, j) => (
              <td key={col.key} data-label={col.label} className={j === 0 ? 'cy-table__key' : ''}>
                {row[col.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DataTable;
